(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["locations-interactive"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    const finder = document.querySelector('[data-locations-finder]');
    const mapLink = document.querySelector('[data-map-link]');

if (mapLink) {
  const desktopUrl = mapLink.dataset.mapDesktop || '';
  const mobileUrl = mapLink.dataset.mapMobile || '';

  function updateMapLink() {
    if (window.innerWidth <= 749 && mobileUrl) {
      mapLink.href = mobileUrl;
    } else {
      mapLink.href = desktopUrl;
    }
  }

  updateMapLink();
  window.addEventListener('resize', updateMapLink);
}

    if (finder) {
      const tabs = finder.querySelectorAll('[data-location-tab]');
const mobileSelect = finder.querySelector('[data-location-select]');
const previewTitle = finder.querySelector('[data-preview-title]');
const previewAddress = finder.querySelector('[data-preview-address]');
const previewPhone = finder.querySelector('[data-preview-phone]');
const previewPhoneLink = finder.querySelector('[data-preview-phone-link]');
const previewMf = finder.querySelector('[data-preview-mf]');
const previewSs = finder.querySelector('[data-preview-ss]');
const previewMap = finder.querySelector('[data-preview-map]');
const previewJump = finder.querySelector('[data-preview-jump]');
const previewMedia = finder.querySelector('.locations-tool__preview-media');

      function setActiveTab(activeTab) {
        tabs.forEach((tab) => {
          const isActive = tab === activeTab;
          tab.classList.toggle('is-active', isActive);
          tab.setAttribute('aria-selected', isActive ? 'true' : 'false');
        });
      }

      function updatePreviewFromData(data) {
  const id = data.locationId || '';
  const title = data.locationTitle || '';
  const address = data.locationAddress || '';
  const phone = data.locationPhone || '';
  const mf = data.locationMf || '';
  const ss = data.locationSs || '';
  const map = data.locationMap || '';
  const image = data.locationImage || '';

  if (previewTitle) previewTitle.textContent = title;
  if (previewAddress) previewAddress.textContent = address;
  if (previewMf) previewMf.textContent = mf;
  if (previewSs) previewSs.textContent = ss;
  if (previewMap) previewMap.href = map;
  if (previewJump) previewJump.href = '#location-' + id;

  

  if (previewPhone && previewPhoneLink) {
    if (phone) {
      previewPhone.textContent = phone;
      previewPhoneLink.href = 'tel:' + phone.replace(/\s+/g, '');
      previewPhoneLink.parentElement.hidden = false;
    } else {
      previewPhone.textContent = '';
      previewPhoneLink.href = '#';
      previewPhoneLink.parentElement.hidden = true;
    }
  }

  if (previewMedia) {
    if (image) {
      previewMedia.innerHTML = '<img src="' + image + '" alt="' + title.replace(/"/g, '&quot;') + '" class="locations-tool__preview-image">';
    } else {
      previewMedia.innerHTML = '';
    }
  }
}

      tabs.forEach((tab) => {
  tab.addEventListener('click', function () {
    setActiveTab(tab);
    updatePreviewFromData(tab.dataset);

    if (mobileSelect) {
      mobileSelect.value = tab.dataset.locationId || '';
    }
  });
});

if (mobileSelect) {
  mobileSelect.addEventListener('change', function () {
    const selectedId = mobileSelect.value;
    const matchingTab = finder.querySelector('[data-location-tab][data-location-id="' + selectedId + '"]');

    if (matchingTab) {
      setActiveTab(matchingTab);
      updatePreviewFromData(matchingTab.dataset);
    }
  });
}

if (tabs.length) {
  setActiveTab(tabs[0]);
  updatePreviewFromData(tabs[0].dataset);

  if (mobileSelect) {
    mobileSelect.value = tabs[0].dataset.locationId || '';
  }
}
    }

    const sliders = document.querySelectorAll('[data-location-slider]');

    sliders.forEach((slider) => {
      const slides = slider.querySelectorAll('.location-card__slide');
      const prevButton = slider.querySelector('.location-card__arrow--prev');
      const nextButton = slider.querySelector('.location-card__arrow--next');
      const dotsContainer = slider.querySelector('.location-card__dots');

      if (!slides.length) return;

      let currentIndex = 0;

      if (slides.length <= 1) {
        if (prevButton) prevButton.style.display = 'none';
        if (nextButton) nextButton.style.display = 'none';
        if (dotsContainer) dotsContainer.style.display = 'none';
        slides[0].classList.add('is-active');
        return;
      }

      function renderSlides() {
        slides.forEach((slide, index) => {
          slide.classList.toggle('is-active', index === currentIndex);
        });

        const dots = dotsContainer.querySelectorAll('button');

        dots.forEach((dot, index) => {
          dot.classList.toggle('is-active', index === currentIndex);
          dot.setAttribute('aria-current', index === currentIndex ? 'true' : 'false');
        });
      }

      function goToSlide(index) {
        currentIndex = index;
        if (currentIndex < 0) currentIndex = slides.length - 1;
        if (currentIndex >= slides.length) currentIndex = 0;
        renderSlides();
      }

      slides.forEach((_, index) => {
        const dot = document.createElement('button');
        dot.type = 'button';
        dot.setAttribute('aria-label', `Go to image ${index + 1}`);
        dot.addEventListener('click', function () {
          goToSlide(index);
        });
        dotsContainer.appendChild(dot);
      });

      prevButton.addEventListener('click', function () {
        goToSlide(currentIndex - 1);
      });

      nextButton.addEventListener('click', function () {
        goToSlide(currentIndex + 1);
      });

      renderSlides();
    });

    const jumpLinks = document.querySelectorAll('[data-preview-jump]');

    jumpLinks.forEach((link) => {
      link.addEventListener('click', function (event) {
        const targetId = link.getAttribute('href');
        if (!targetId || !targetId.startsWith('#')) return;

        const target = document.querySelector(targetId);
        if (!target) return;

        event.preventDefault();

        target.scrollIntoView({
          behavior: 'smooth',
          block: 'start'
        });

        target.classList.add('is-highlighted');

        setTimeout(function () {
          target.classList.remove('is-highlighted');
        }, 1600);
      });
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-locations"]) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    const sliders = document.querySelectorAll('[data-location-slider]');

    sliders.forEach((slider) => {
      const slides = slider.querySelectorAll('.location__image');
      const prevButton = slider.querySelector('.location-slider-arrow--prev');
      const nextButton = slider.querySelector('.location-slider-arrow--next');
      const dotsContainer = slider.querySelector('.location-slider-dots');

      if (!slides.length) return;

      let currentIndex = 0;

      if (slides.length <= 1) {
        if (prevButton) prevButton.style.display = 'none';
        if (nextButton) nextButton.style.display = 'none';
        if (dotsContainer) dotsContainer.style.display = 'none';
        slides[0].classList.add('is-active');
        return;
      }

      function renderSlides() {
        slides.forEach((slide, index) => {
          slide.classList.toggle('is-active', index === currentIndex);
        });

        const dots = dotsContainer.querySelectorAll('button');

        dots.forEach((dot, index) => {
          dot.classList.toggle('is-active', index === currentIndex);
          dot.setAttribute('aria-current', index === currentIndex ? 'true' : 'false');
        });
      }

      function goToSlide(index) {
        currentIndex = index;
        if (currentIndex < 0) currentIndex = slides.length - 1;
        if (currentIndex >= slides.length) currentIndex = 0;
        renderSlides();
      }

      slides.forEach((_, index) => {
        const dot = document.createElement('button');
        dot.type = 'button';
        dot.setAttribute('aria-label', `Go to image ${index + 1}`);
        dot.addEventListener('click', function () {
          goToSlide(index);
        });
        dotsContainer.appendChild(dot);
      });

      prevButton.addEventListener('click', function () {
        goToSlide(currentIndex - 1);
      });

      nextButton.addEventListener('click', function () {
        goToSlide(currentIndex + 1);
      });

      renderSlides();
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-recommendations"]) return;
  try {
    
  class ProductRecommendations extends HTMLElement {
    constructor() {
      super();

      const handleIntersection = (entries, observer) => {
        if (!entries[0].isIntersecting) return;
        observer.unobserve(this);

        fetch(this.dataset.url)
          .then(response => response.text())
          .then(text => {
            const html = document.createElement('div');
            html.innerHTML = text;
            const recommendations = html.querySelector('product-recommendations');

            if (recommendations && recommendations.innerHTML.trim().length) {
              this.innerHTML = recommendations.innerHTML;
            }

            if (html.querySelector('.grid__item')) {
              this.classList.add('product-recommendations--loaded');
            }
          })
          .catch(e => {
            console.error(e);
          });
      }

      new IntersectionObserver(handleIntersection.bind(this), {rootMargin: '0px 0px 200px 0px'}).observe(this);
    }
  }

  customElements.define('product-recommendations', ProductRecommendations);

  } catch(e) { console.error(e); }
})();
})();
